import React, { Component } from "react";
import { HOST_URL } from "../../constants";
import i18next from "i18next";
import { Translation } from "react-i18next";
import "../../css/CheckEmail.css";
import { connect } from "react-redux";
import { customer } from "../../models";

export class CheckEmail extends Component {
  state = {
    onChangeEmailValue: "",
    emailRepeatedlyUsed: false,
    warningEmailRule: false
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.CheckEmailDisplayStatus !== this.props.CheckEmailDisplayStatus
    ) {
      if (!this.props.CheckEmailDisplayStatus) {
        this.setState({
          onChangeEmailValue: "",
          emailRepeatedlyUsed: false,
          warningEmailRule: false
        });
      }
    }
  }

  sendMemberEmail = async () => {
    const { onChangeEmailValue } = this.state;
    const { closeCheckEmailPage, fetchCustomer } = this.props;
    let emailRule = new RegExp(
      "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,6}$"
    );
    if (!emailRule.test(onChangeEmailValue)) {
      // 顯示信箱格式有誤的提示文字
      this.setState({
        warningEmailRule: true
      });
    } else {
      this.setState({
        warningEmailRule: false
      });
      try {
        const response = await fetch(`${HOST_URL}/shopping/v1/customers/info`, {
          credentials: "include",
          method: "PATCH",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ email: onChangeEmailValue })
        });
        if (response.status === 204) {
          // 回傳值 204 成功的時候
          // 1. 關閉畫面
          this.props.closeCheckEmailPage();
          // 2. 切換成正常執行下一步的按鈕
          this.props.closeCheckEmailButton();
          // 3. 重新取得 customer 資料
          fetchCustomer();
        } else {
          const data = await response.json();
          if (data.hasOwnProperty("errors")) {
            data.errors.forEach(error => {
              if (
                error.errorCode === "E00001" ||
                error.errorCode === "E00002"
              ) {
                this.setState({ emailRepeatedlyUsed: true });
              }
            });
          } else {
            closeCheckEmailPage();
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  onChangeEmail = e => {
    this.setState({ onChangeEmailValue: e.target.value });
  };

  closePageFromBackground = e => {
    const { className } = e.target;
    if (className === "check-email-bg") {
      this.props.closeCheckEmailPage();
    }
  };

  render() {
    const { onChangeEmailValue, emailRepeatedlyUsed, warningEmailRule } =
      this.state;
    const { CheckEmailDisplayStatus, closeCheckEmailPage } = this.props;
    return (
      <div
        className="check-email-bg"
        style={{
          opacity: CheckEmailDisplayStatus ? "1" : "0",
          pointerEvents: CheckEmailDisplayStatus ? "" : "none"
        }}
        onClick={this.closePageFromBackground}
      >
        <div
          className="check-email-modal"
          style={{
            transform: CheckEmailDisplayStatus
              ? "translateY(0px)"
              : "translateY(-25px)"
          }}
        >
          <Translation>
            {t => (
              <p className="checkout-email-title">{t("checkoutEmail.title")}</p>
            )}
          </Translation>
          <div className="check-email-body">
            <input
              type="text"
              placeholder={i18next.t("checkoutEmail.inputPrompt")}
              onChange={this.onChangeEmail}
              value={onChangeEmailValue}
              className="check-email-input"
              style={{
                border:
                  emailRepeatedlyUsed || warningEmailRule
                    ? "1px solid #b72126"
                    : "1px solid #e5e5e5"
              }}
            />
            {emailRepeatedlyUsed ? (
              <Translation>
                {t => (
                  <p className="check-email-warning-text">
                    {t("checkoutEmail.errorMessage")}
                  </p>
                )}
              </Translation>
            ) : null}

            {warningEmailRule ? (
              <p className="check-email-warning-text">
                <Translation>
                  {t => <>{t("checkoutEmail.warningEmailRule")}</>}
                </Translation>
              </p>
            ) : null}

            <Translation>
              {t => (
                <button
                  className="check-email-button"
                  onClick={this.sendMemberEmail}
                >
                  {t("checkoutEmail.sendButtonText")}
                </button>
              )}
            </Translation>
          </div>
          <button
            type="button"
            className="check-email-closebtn"
            aria-label="Remove item"
            onClick={closeCheckEmailPage}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    region: state.countryList.region
  };
};

const mapDispatchToProps = () => {
  return {
    fetchCustomer: () => customer.actions.fetchCustomer()
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckEmail);
